const defaultGroups = [
  {
    name: "Gruppe Homogen",
    teams: [
      { name: "Team A1", points: 9 },
      { name: "Team A2", points: 6 },
      { name: "Team A3", points: 3 },
      { name: "Team A4", points: 0 }
    ]
  },
  {
    name: "Gruppe des Schreckens",
    teams: [
      { name: "Team B1", points: 7 },
      { name: "Team B2", points: 7 },
      { name: "Team B3", points: 3 },
      { name: "Team B4", points: 0 }
    ]
  },
  {
    name: "Gruppe 1887",
    teams: [
      { name: "Team C1", points: 9 },
      { name: "Team C2", points: 4 },
      { name: "Team C3", points: 4 },
      { name: "Team C4", points: 1 }
    ]
  },
  {
    name: "Gruppe Overdose",
    teams: [
      { name: "Team D1", points: 6 },
      { name: "Team D2", points: 6 },
      { name: "Team D3", points: 3 },
      { name: "Team D4", points: 3 }
    ]
  },
  {
    name: "Gruppe Couple Goals",
    teams: [
      { name: "Team E1", points: 9 },
      { name: "Team E2", points: 6 },
      { name: "Team E3", points: 1 },
      { name: "Team E4", points: 1 }
    ]
  },
  {
    name: "Gruppe Hopfen und Malz verloren",
    teams: [
      { name: "Team F1", points: 8 },
      { name: "Team F2", points: 5 },
      { name: "Team F3", points: 4 },
      { name: "Team F4", points: 0 }
    ]
  }
];

export default defaultGroups;